module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO56Errores.43951c1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO56Errores.mp4
// module id = 782
// module chunks = 1